<template>
  <div id="app" :style="style">
    <div class="show-content">
      <!--          <div class="enter-btn" v-if="status == 1" :style="{backgroundImage: 'url(' + backGroundImg + ')'}"-->
      <!--               @click="appRun"></div>-->
      <template v-if="status == 2">
        <loading v-if="carConfig.newLoading" :progress="progress"/>
        <div class="loading" v-else>
          <div class="round">
            <div class="top"></div>
            <div class="round-line"></div>
          </div>
          <div id="percentNum">{{ progress }}%</div>
          <div class="progress_area">
            <div id="progress" :style="{width: progress+'%'}"></div>
            <div class="progress-line"></div>
          </div>
        </div>
      </template>

      <div class="iframe360" id="iframe-360-box" v-if="status != 1">
        <template v-if="iframeUrl">
          <iframe class="iframe" id="iframe_360" :src="iframeUrl"
                  :class="[{interShowing:showType!=='outer'&&carConfig.interUseImg},`status${status}`]"></iframe>
        </template>
        <template v-if="carConfig.interUseImg&&showType==='inter'">
          <inter-iframe/>
        </template>

      </div>
      <div class="control-content" :class="showType == 'inter' ? 'innerCar' : ''" v-if="status != 1">
        <div class="t-content">
          <div class="t-btn" :class=" showType == 'outer' ? 'active' : ''" @click="switchCar('outer')">外观
          </div>
          <div class="division"></div>
          <div class="t-btn" :class=" showType == 'inter' ? 'active' : ''" @click="switchCar('inter')">内室
          </div>
        </div>
        <div class="select-car" @click="selectCar">
          <div class="name" v-if="selectTypeItem.showTypeName">{{selectTypeItem.showTypeName}}</div>
          <div class="name" v-else>
            {{ selectTypeItem.name }} {{ selectTypeItem.describe }} {{ selectTypeItem.subDescribe }}
          </div>
          <div class="arrow" v-if="viewTypeArr.length>1"><i class="down" :class="selectCarShow ? 'up' : ''"></i></div>
          <div class="select-list" v-if="selectCarShow">
            <div class="item clearFix" v-for="(type, index) in viewTypeArr" :key="index"
                 @click.stop="typeSelect(type.code)">
              <div class="selected-box">
                <div class="selected" :style="{opacity: type.code===useId ? '1' : '0'}"></div>
              </div>
              <div class="name">{{ type.name }} {{ type.describe }} {{ type.subDescribe }}</div>
            </div>
          </div>
        </div>
        <template v-if="hasInit">
          <outer v-show="showType==='outer'"></outer>
          <inner v-if="showType==='inter'"></inner>
        </template>
        <div class="show-tips" :class="showType">
          {{showType === 'inter'&&useId==='EX2'?"*此为选装多感纯享套装内室，仅作为内饰颜色分布示意":"图片仅供参考，具体以实车为准"}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";
import rx_pc from '../static/img/rx-pc.gif'
import '../utils/app.js'
import outer from './outer'
import inner from './inner'
import {iframeBaseUrl} from "@/config";
import {getCameraConfig, getUrlParams, isInIframe, paramToString} from "@/utils";
import InterIframe from "@/views/inter-iframe.vue";
import Loading from "@/views/loading.vue";

export default {
  name: "index",
  components: {
    Loading,
    InterIframe,
    outer,
    inner
  },
  created() {
    // const {innerWidth,outerWidth,innerHeight,outerHeight} = window
    // this.style={
    //     width:`${outerWidth}px`,
    //     height:`${innerHeight}px`,
    //     left:`-${(outerWidth-innerWidth)/2}px`,
    // }
  },
  mounted() {
    this.CAR = getUrlParams().car || 'rz'
    // this.backGroundImg = require(`../static/img/${this.CAR}${document.body.clientWidth > 768?'-pc':''}.gif`)
    this.initPage()

    // try {
    //   const height = this.getUrlParams().height - 100
    //   if(!isMobile){
    //     // 外部壳子最大990
    //     this.height = Math.min(height,890)
    //     this.style = {
    //       height: this.height + 'px'
    //     }
    //   }
    // } catch (e) {
    //
    // }
  },
  data() {
    return {
      height: 0,
      style: {},
      CAR: '',
      backGroundImg: rx_pc,
      progress: 0,
      iframeUrl: '',
      status: 2,
      selectCarShow: false,
      vmSelectTypeId: '',
    }
  },
  computed: {
    ...mapGetters(['selectTypeItem']),
    ...mapState({
      carConfig: state => state.carConfig,
      selectColorCode: state => state.selectColorCode,
      selectInterCode: state => state.selectInterCode,
      typeArr: state => state.carConfig.typeArr || [],
      selectTypeId: state => state.selectTypeId,
      showType: state => state.showType,
      hasInit: state => state.hasInit,
    }),
    useId: vm => vm.vmSelectTypeId || vm.selectTypeId,
    viewTypeArr: vm => vm.showType === 'inter' ? vm.typeArr.filter(e => !e.interDisSelect&&!e.webInterDisSelect) : vm.typeArr.filter(e => !e.outerDisSelect)
  },
  methods: {
    ...mapActions(['initStore', "setAppState", "setSelectTypeId", "setShowType"]),
    ...mapMutations(['setInitState']),

    appRun() {
      // this.iframeUrl = window.location.href.split('lexus_web')[0] + 'officialwebsite/template.html' + `#${this.CAR.toLowerCase()}`
      // `https://cdn.lexus.areyeshot.com/uploads/car-model/newWeb/officialwebsite/template.html#rz`

      const {carConfig,selectTypeItem} = this
      const {independent,shineId,id}=carConfig
      const {query = {}, code, name} = selectTypeItem
      const car = shineId||id
      const queryStr = paramToString({
        ...query,
        car,
        type: code,
        inter: this.selectInterCode,
        outer: this.selectColorCode,
        camera: encodeURIComponent(getCameraConfig(car).join(',')),
        h: new Date().getHours()
      })
      const html = independent ? `lexus_mini_web/${car}/template.html` : `officialwebsite/export.html`
      this.iframeUrl = `${iframeBaseUrl}${html}` + `#${queryStr}`;
      this.status = 2
      let _timer = setInterval(() => {
        if (this.progress > 98) {
          clearInterval(_timer)
        } else {
          this.progress = (Number(this.progress) + (~~(Math.random() * 10) / 10)).toFixed(0)
        }
      }, 50)

      window.loadFinish = () => {
        setTimeout(() => {
          this.setInitState(true)
          this.setAppState()
          this.$nextTick(() => {
            this.status = 3
          })
        },500)
      }
      // window.loadFinish()
    },
    initPage() {
      this.initStore(this.CAR).then(this.appRun)
    },
    switchCar(type) {
      this.setShowType(type)
    },
    selectCar() {
      if (this.viewTypeArr.length > 1) {
        this.selectCarShow = !this.selectCarShow
      }
    },
    typeSelect(code) {
      this.selectCarShow = false
      if (this.vmSelectTypeId !== code) {
        this.vmSelectTypeId = code
        console.log(this.useId)
        this.setSelectTypeId(this.vmSelectTypeId)
      }
    }
  }
}
</script>

<style lang="less">

.interShowing {
  display: none;
}

.show-tips{
  position: absolute;
  z-index: 3;
  font-size: 12px;
  height: 22px;
  line-height: 22px;
  color: #c0c4cc;
  font-weight: 400;

  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
}

.show-content {
  width: 100%;
  height: 100%;
  position: relative;
  //background: #999999;

  iframe {
    width: 100%;
    height: 100%;
    border: none;
    &.status3{
      height: 99%;
    }
  }

  .enter-btn {
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    background-color: #d9dae0;
    z-index: 100;
  }

  .loading {
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 99;
    left: 0;
    top: 0;
    background-color: #eee;

    .round {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .round .top {
      left: 50%;
      top: 50%;
      position: absolute;
      transform: translate(-50%, -50%);
      z-index: 3;
      width: 83px;
      height: 82px;
      background: url("../static/img/loading-3.png") no-repeat;
      background-size: 100% 100%;
    }

    .round .round-line {
      position: relative;
      z-index: 2;
      width: 87px;
      height: 87px;
      background: url("../static/img/loading-2.png") no-repeat;
      background-size: 100% 100%;
      animation: round 2s linear infinite;
    }

    @media (max-width: 768px) {
      .round {
        position: absolute;
        top: 30%;
        left: 50%;
        transform: translateX(-50%);
        width: 84px;
        height: 86px;
        //background: url("../static/img/loading-1-mob.png") no-repeat;
        background-size: 100% 100%;
      }

      .round .top {
        //position: absolute;
        //top: 9px;
        //left: 7px;
        z-index: 3;
        width: 70px;
        height: 69px;
        background: url("../static/img/loading-3-mob.png") no-repeat;
        background-size: 100% 100%;
      }

      .round .round-line {
        //position: absolute;
        //top: 8px;
        //left: 7px;
        z-index: 2;
        width: 70px;
        height: 70px;
        background: url("../static/img/loading-2-mob.png") no-repeat;
        background-size: 100% 100%;
        animation: round 2s linear infinite;
      }
    }
    @media (min-width: 768px) {
      .round {
        position: absolute;
        top: 30%;
        left: 50%;
        transform: translateX(-50%);
        width: 101px;
        height: 101px;
        //background: url("../static/img/loading-1.png") no-repeat;
        background-size: 100% 100%;
      }
    }
    @media (min-width: 1200px) {
      .round {
        position: absolute;
        top: 35%;
        left: 50%;
        transform: translateX(-50%);
        width: 101px;
        height: 101px;
        //background: url("../static/img/loading-1.png") no-repeat;
        background-size: 100% 100%;
      }
    }
    @media (min-width: 1480px) {
      .round {
        position: absolute;
        top: 40%;
        left: 50%;
        transform: translateX(-50%);
        width: 101px;
        height: 101px;
        //background: url("../static/img/loading-1.png") no-repeat;
        background-size: 100% 100%;
      }
    }

    @keyframes round {
      from {
        transform: rotate(0);
      }
      to {
        transform: rotate(-360deg);
      }
    }

    .progress_area {
      width: 50vw;
      height: 15px;
      position: absolute;
      top: 60%;
      left: 50%;
      margin-left: -25vw;
      margin-top: -10px;
    }

    .progress_area .progress-line {
      width: 50vw;
      height: 1px;
      border-bottom: 1px solid #999;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-left: -25vw;
      margin-top: -10px;
    }

    #progress {
      width: 0%;
      position: absolute;
      left: 0;
      top: -4px;
      z-index: 4;
      height: 8px;
      border-radius: 8px;
      background-color: #555;
      transition: width 0.2s ease-out;
    }

    @media (max-width: 768px) {
      #progress {
        width: 0%;
        position: absolute;
        left: 0;
        top: -4px;
        z-index: 4;
        height: 5px;
        border-radius: 5px;
        background-color: #555;
        transition: width 0.2s ease-out;
      }
    }

    #percentNum {
      position: absolute;
      top: 62%;
      width: 100px;
      text-align: center;
      left: 50%;
      margin-top: 0;
      margin-left: -50px;
      font-size: 14px;
    }
  }
}

.control-content {
  pointer-events: none;

  div {
    pointer-events: auto;
  }
}

.innerCar {
  .t-content {
    background: linear-gradient(89.98deg, rgba(0, 0, 0, 0) 0.02%, rgba(58, 58, 58, 0.61) 55.26%, rgba(0, 0, 0, 0) 101.03%);

    .t-btn {
      color: #A8A8A8;
    }

    .division {
      background: #A8A8A8;
    }

    .active {
      color: #FFFFFF;
    }
  }

  .select-car {
    .name {
      color: #FFFFFF;
    }

    .arrow {
      background: #FFFFFF;

      .down {
        border-color: #000000;
      }
    }
  }

  .b-content {
    background: linear-gradient(89.98deg, rgba(0, 0, 0, 0) 0.02%, rgba(58, 58, 58, 0.61) 55.26%, rgba(0, 0, 0, 0) 101.03%);

    .swiper-container {
      .swiper-slide-active-item {
        .slide-content {
          .color {
            border: 1px solid #FFFFFF;
          }

          .name {
            color: #FFFFFF;
          }
        }
      }
    }
  }
}

.color-inner {
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}

@import "max500";
@import "max";

@import "max960";

</style>
